import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-what-iwork-with',
  templateUrl: './what-iwork-with.component.html',
  styleUrls: ['./what-iwork-with.component.scss']
})
export class WhatIWorkWithComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
